import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Button from 'vibo-ui/Button';
import SettingsItem from './SettingsItem';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useModal } from 'vibo-ui/Modal';

import { Modals } from 'types/enums';

import useStyles from './style';

const ChangePassword: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { openModal } = useModal();

  const openChangePasswordModal = useCallback(
    () =>
      openModal({
        key: Modals.changePassword,
      }),
    []
  );

  return (
    <SettingsItem>
      <div className={classNames('label', classes.label)}>
        <Icon icon={IconmoonFont['locked-24']} className={classes.generalIcon} />
        <Button onClick={openChangePasswordModal} displayType="link">
          {t('changePassword')}
        </Button>
      </div>
    </SettingsItem>
  );
};

export default ChangePassword;
